// i18n 初始化。当前只装中文(zh-CN);保留多语言框架以便未来扩展。
// 新增 locale:在 ./locales/ 下放 <bcp47>.json,在 resources 里加一项,在 supportedLngs 里加 code。
//
// === key 命名约定(zh-CN.json)===
// 默认 lowerCamelCase 点路径:nav.users / sidebar.groups.operations / pages.overview.title。
// 例外:auth.login.error.* 的叶子用 snake_case(invalid_credentials / login_rate_limited /
// rate_limited 等),刻意跟 gateway 的 errorCode 字面对齐 —— Login.tsx 的 ERROR_KEY_MAP
// 可以 grep 一处串通"errorCode → i18n key → 文案"链路。
// 同理:topbar.user.status.{active,disabled} 跟 AdminUser.status 枚举值对齐。
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhCN from './locales/zh-CN.json'

void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN }
  },
  lng: 'zh-CN',
  fallbackLng: 'zh-CN',
  supportedLngs: ['zh-CN'],
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
})

export default i18n
